import vars from 'src/common/vars';
import { isInDiscordIFrame } from './isInDiscordIFrame';
import isServer from './isServer';

export default function assetUrl(path) {
  return isServer() || !isInDiscordIFrame()
    ? `${vars.get('ASSET_LOC')}${path}`
    : `/cdn/web/${path}`;
}
